import * as angular from 'angular';
import AngularSidebarJS from 'angular-sidebarjs';
import sidebarComponent from './sidebar.component';
import sidebarService from './sidebar.service';


export default angular
  .module('SidebarModule', [
    AngularSidebarJS,
  ])
  .component('sidebar', sidebarComponent)
  .factory('SidebarService', sidebarService)
  .name;



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.module.js